import { MySubscriptionResponse } from '@core/models';

export class SetMySubscription {
  static readonly type = '@@SET_MY_SUBSCRIPTION';

  constructor(public payload: MySubscriptionResponse) {}
}

export class GetMySubscription {
  static readonly type = '@@GET_MY_SUBSCRIPTION';

  constructor() {}
}

export class GetAppliedCoupons {
  static readonly type = '@@GET_APPLIED_COUPONS';

  constructor() {}
}

export class GetAdSpend {
  static readonly type = '@@GET_AD_SPEND';

  constructor() {}
}
